import produce from 'immer';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { FuseSearchIndexItem } from '../modules/MagicSearch/plugins/fuseSearchPlugin';

type AppStore = {
  globalSearch: {
    indexItems: FuseSearchIndexItem[];
    indexItemsPaths: string[];
    addIndexItems: ({
      path,
      indexItems,
    }: {
      path: string;
      indexItems: FuseSearchIndexItem[];
    }) => void;
  };
  sidebarOpen: boolean;
  config?: Record<string, string>;
};

export const useAppStore = create<AppStore>()(
  persist(
    (set, get) =>
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      ({
        globalSearch: {
          indexItems: [],
          indexItemsPaths: [],
          addIndexItems: ({ path, indexItems }) => {
            const state = get();
            if (!state.globalSearch.indexItemsPaths.includes(path)) {
              set({
                globalSearch: produce(state.globalSearch, draftGlobalSearch => {
                  draftGlobalSearch.indexItems.push(...indexItems);
                  draftGlobalSearch.indexItemsPaths.push(path);
                }),
              });
            } else {
              set({
                globalSearch: produce(state.globalSearch, draftGlobalSearch => {
                  // Unfortunately, this is an O(n^2) operation, but the number of index items should be small
                  const indexItemsNotPresent = indexItems.filter(
                    indexItem =>
                      !draftGlobalSearch.indexItems.find(
                        draftIndexItem =>
                          draftIndexItem.path === indexItem.path &&
                          draftIndexItem.title === indexItem.title,
                      ),
                  );
                  draftGlobalSearch.indexItems.push(...indexItemsNotPresent);
                }),
              });
            }
          },
        },
        sidebarOpen: false,
        config: {},
      } as AppStore),
    {
      // Local Storage key
      name: 'gen-ai-ops-hub-app-store',
      partialize: ({ sidebarOpen }) => ({
        sidebarOpen,
      }),
    },
  ),
);
